import React from 'react'
import Modal from '~/components/Modal'
import LocationCard from './LocationCard'
import { ICompany } from '@verzekeringapp-mono/shared/src/api/types/company'

interface IProps {
  location: ICompany
  onClose: () => void
}

const LocationCardModal = ({ location, onClose }: IProps) => (
  <Modal onClose={onClose}>
    <LocationCard location={location} />
  </Modal>
)

export default LocationCardModal
